import {
  CHANGE_ACTIVE_TS_EXPERT,
  CHANGE_ACTIVE_ITEM_LIVELIST,
  CHANGE_ACTIVE_ITEM_LIVELIST_MATRIX,
  CHANGE_ACTIVE_ITEM_OSCILLOSCOPE,
  CHANGE_ACTIVE_ITEM_BAR_GRAPH,
  CHANGE_ACTIVE_ITEM_OPTIC_FIBER,
  CHANGE_ACTIVE_ITEM_OPTIC_FIBER_LOG,
  CHANGE_ACTIVE_ITEM_LOG,
  CHANGE_ACTIVE_ITEM_CONFIG,
  SOLVE_PROBLEM,
} from "../actions/types";

// ---- Actions ----
export function tsExpertAction() {
  return {
    type: CHANGE_ACTIVE_TS_EXPERT,
    payload: { activeItem: "/" }
  };
}

export function liveListAction() {
  return {
    type: CHANGE_ACTIVE_ITEM_LIVELIST,
    payload: { activeItem: "/live-list" }
  };
}

export function liveListMatrixAction() {
  return {
    type: CHANGE_ACTIVE_ITEM_LIVELIST_MATRIX,
    payload: { activeItem: "/live-list-matrix" }
  };
}

export function oscilloscopeAction() {
  return {
    type: CHANGE_ACTIVE_ITEM_OSCILLOSCOPE,
    payload: { activeItem: "/oscilloscope" }
  };
}

export function barGraphAction() {
  return {
    type: CHANGE_ACTIVE_ITEM_BAR_GRAPH,
    payload: { activeItem: "/bar-graph" }
  };
}

export function opticFiberAction() {
  return {
    type: CHANGE_ACTIVE_ITEM_OPTIC_FIBER,
    payload: { activeItem: "/optic-fiber" }
  };
}

export function OpticFiberLogAction() {
  return {
    type: CHANGE_ACTIVE_ITEM_OPTIC_FIBER_LOG,
    payload: { activeItem: "/optic-fiber-log" }
  };
}

export function logAction() {
  return {
    type: CHANGE_ACTIVE_ITEM_LOG,
    payload: { activeItem: "/log" }
  };
}

export function configAction() {
  return {
    type: CHANGE_ACTIVE_ITEM_CONFIG,
    payload: { activeItem: "/config" }
  };
}

export function solveProblemAction(solve, problem) {
  return {
    type: SOLVE_PROBLEM,
    payload: {
      solve: solve,
      problem: problem
    }
  };
}